import React from 'react';
import { T } from '../tokens';
import { useTheme } from '../theme';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  pad?: React.CSSProperties['padding'];
  style?: React.CSSProperties;
}

export function Card({ children, style = {}, onClick, pad, ...rest }: CardProps) {
  const t = useTheme();
  return (
    <div onClick={onClick} {...rest} style={{
      background: T.surface,
      border: `1px solid ${T.border}`,
      borderRadius: t.radius + 4,
      padding: pad,
      ...style,
    }}>
      {children}
    </div>
  );
}

export interface EyebrowProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: string;
  style?: React.CSSProperties;
}

export function Eyebrow({ children, style = {}, color }: EyebrowProps) {
  return (
    <div style={{
      fontSize: 10,
      fontWeight: 800,
      letterSpacing: '0.16em',
      textTransform: 'uppercase',
      color: color || T.fg3,
      ...style,
    }}>
      {children}
    </div>
  );
}
